import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectTranslate } from '@pegasus/translation';

import { getClientDeviceWidth } from '@client/redux/modules/clientDevice/selectors';
import { isSmScreen } from '@client/helpers/screens';
import { Grid, GridRow, GridCol } from '@lux/grid';
import { ANIMATION_WAIT } from '../constants';

import Tab from './Tab';
import * as S from './tabs.styles';

export class Tabs extends PureComponent {
    static propTypes = {
        tabs: PropTypes.array.isRequired,
        onTabClick: PropTypes.func.isRequired,
        translate: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.tabsRef = React.createRef();
        this.tabsWrapperRef = React.createRef();
    }

    render() {
        const { tabs, activeIndex } = this.props;

        return (
            <Grid className="tabs__wrapper">
                <GridRow>
                    <GridCol span={12}>
                        <S.TabsContainer ref={this.tabsWrapperRef}>
                            <S.Tabs
                                ref={this.tabsRef}
                                role="tablist"
                                aria-label={this.props.translate('a11y.categories')}
                            >
                                {tabs.map(tab => {
                                    const tabIndex = tabs.indexOf(tab);

                                    return (
                                        <Tab
                                            key={tab.id}
                                            name={this.normalizeTabName(tab.name)}
                                            index={tabIndex}
                                            active={tabIndex === activeIndex}
                                            onAction={this.changeTab}
                                        />
                                    );
                                })}
                            </S.Tabs>
                        </S.TabsContainer>
                    </GridCol>
                </GridRow>
            </Grid>
        );
    }

    componentDidMount = () => {
        this.updateTabsPosition();
    };

    componentDidUpdate = prevProps => {
        const { activeIndex } = this.props;

        if (prevProps.activeIndex !== activeIndex) {
            this.updateTabsPosition();
        }
    };

    normalizeTabName = name => {
        if (typeof name !== 'string') {
            return '';
        }

        return name;
    };

    changeTab = tabIndex => {
        const { onTabClick, deviceWidth } = this.props;
        const timeout = isSmScreen(deviceWidth) ? ANIMATION_WAIT : 0;
        onTabClick(tabIndex, timeout);
    };

    updateTabsPosition = () => {
        const { activeIndex, deviceWidth, tabs } = this.props;
        const tabsElem = this.tabsRef.current;

        if (!tabsElem || !tabs || !tabs.length || !tabs[activeIndex]) {
            return;
        }

        if (!isSmScreen(deviceWidth)) {
            tabsElem.parentElement.scrollLeft = 0;

            return;
        }

        const { width: containerWidth } = this.tabsWrapperRef.current.getBoundingClientRect();
        const children = Array.from(tabsElem.childNodes);
        const { x, width } = children[activeIndex]?.getBoundingClientRect();

        const difference = containerWidth * 0.5 - width * 0.5 - x;
        // eslint-disable-next-line operator-assignment
        tabsElem.parentElement.scrollLeft = tabsElem.parentElement.scrollLeft - difference;
    };
}

const mapStateToProps = state => ({
    deviceWidth: getClientDeviceWidth(state),
});

export default connect(mapStateToProps, {})(injectTranslate(Tabs));
